// 设置用户登录 token
export const SET_USER_LOGIN_INFO = (state, data) => {
  state.token 		= data.token;					// 设置token
  state.OutTime 	= data.out_time;		  // 设置过期时间
  state.nickName = data.nick_name;   // 用户名称
};

// 设置当前店铺信息
export const SET_Shop_INFO = (state, data) => {
  state.NowShop = data;
}



// WEBPACK FOOTER //
// ./src/store/mutations.js